import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HeaderComponent } from './components/header/header.component';
import { SearchPageComponent } from './components/search-page/search-page.component';
import { ResultCardComponent } from './components/result-card/result-card.component';
import { WhySuggestedBoxComponent } from './components/why-suggested-box/why-suggested-box.component';
import { ThingsToLookIntoBoxComponent } from './components/things-to-look-into-box/things-to-look-into-box.component';
import { FilterBarComponent } from './components/filter-bar/filter-bar.component';
import { UploadDropZoneComponent } from './components/upload-drop-zone/upload-drop-zone.component';
import { ExportButtonComponent } from './components/export-button/export-button.component';
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard.component';
import { EmailActivityComponent } from './components/admin/admin-dashboard/email-activity/email-activity.component';
import { AdminConfigurationComponent } from './components/admin/admin-configuration/admin-configuration.component';
import { AdminPartnersComponent } from './components/admin/admin-partners/admin-partners.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { DrawerComponent } from './components/drawer/drawer.component';
import { RecentRolesComponent } from './components/recent-roles/recent-roles.component';
import { RecentSearchChipsComponent } from './components/recent-search-chips/recent-search-chips.component';
import { ExperienceDrawerComponent } from './components/experience-drawer/experience-drawer.component';
import { SavedSearchesDrawerComponent } from './components/saved-searches-drawer/saved-searches-drawer.component';
import { MessageHistoryDrawerComponent } from './components/message-history-drawer/message-history-drawer.component';
import { BulkActionBarComponent } from './components/bulk-action-bar/bulk-action-bar.component';
import { WeightingDrawerComponent } from './components/weighting-drawer/weighting-drawer.component';
import { ContactModalComponent } from './components/contact-modal/contact-modal.component';
import { ProfileLinksComponent } from './components/profile-links/profile-links.component';
import { AutofocusDirective } from './directives/autofocus.directive';

const SHARED_DECLARATIONS = [
    HeaderComponent,
    SearchPageComponent,
    ResultCardComponent,
    WhySuggestedBoxComponent,
    ThingsToLookIntoBoxComponent,
    FilterBarComponent,
    UploadDropZoneComponent,
    ExportButtonComponent,
    AdminDashboardComponent,
    EmailActivityComponent,
    AdminConfigurationComponent,
    AdminPartnersComponent,
    PaginationComponent,
    DrawerComponent,
    RecentRolesComponent,
    RecentSearchChipsComponent,
    ExperienceDrawerComponent,
    SavedSearchesDrawerComponent,
    MessageHistoryDrawerComponent,
    BulkActionBarComponent,
    WeightingDrawerComponent,
    ContactModalComponent,
    ProfileLinksComponent,
    AutofocusDirective,
] as const;

/**
 * The shared MAPS / Science Talent Network UI: every component, service, and
 * utility that is host-independent. A host must provide two things alongside
 * this module: a configured apollo-angular `Apollo` client for `/maps-graphql`
 * (cookie- or bearer-authenticated) and a `MAPS_HOST_ADAPTER` implementation
 * (see host-adapter.ts). Services are providedIn:'root' and need no listing.
 */
@NgModule({
    declarations: [...SHARED_DECLARATIONS],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    exports: [...SHARED_DECLARATIONS],
})
export class MapsUiModule {}
